import styled from "styled-components";

export const Box = styled.div`
  .interDisplay {
    font-family: InterDisplay;
  }

  .headerTagsCard {
    padding: 1.5rem;
    width: 100%;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
      rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  }

  .resultCard {
    margin-top: 0.5rem;
  }

  .resultCard .card-body {
    padding: 1rem;
  }

  .header-list {
    margin: 0;
    padding-left: 1.25rem;
  }

  .header-list-item {
    margin-bottom: 0.75rem;
    line-height: 1.7;
    word-break: break-word;
  }

  .header-tag {
    font-weight: 600;
    color: #2c3e50;
  }

  .header-title {
    color: #495057;
  }

  @media (max-width: 768px) {
    .headerTagsCard {
      padding: 0.75rem !important;
    }

    .resultCard {
      padding: 0.5rem !important;
    }

    .resultCard .card-body {
      padding: 0.75rem !important;
    }

    .header-list {
      padding-left: 1rem;
    }

    .header-list-item {
      font-size: 14px;
      line-height: 1.6;
    }
  }
`;